<app-maintenance></app-maintenance>

<app-strategy-skeleton
  [isVisible]="isWheelScannerLoadingFirstTime && !(showMaintenance$ | async)"
  [class.loading]="isWheelScannerLoadingFirstTime"
></app-strategy-skeleton>

<!--------------------------------------------------------------
This is separate fragment for only web UI
--------------------------------------------------------------->

@if (!isMobile && !showMaintenance) {
  <div class="main-menu">
    <div class="search-bar-section">
      <div class="header-container desktop-header">
        <p class="header with-divider">
          {{ strategiesNames.Wheel }}
        </p>
      </div>
      <app-search-bar
        [isPowerX]="false"
        #appSearchBar
      ></app-search-bar>
      <!--     use as a slot into symbol-search     -->
      <!-- <app-ai-chat-analyze-button
      [trigger]="analyzeTriggerDetails()"
      *appHideForUnavailableFeature="features.PxoAiChat"
      hint="Analyze this symbol"
    ></app-ai-chat-analyze-button> -->
    </div>
    <app-trading-log-symbol-summary-panel
      [state]="observableServiceV2.tradingLogSymbolSummaryPanelWheelState.value"
      [symbolName]="appSearchBar.selectedSymbol?.symbol"
      (selected)="summaryPanelValueSelected($event)"
      (statechanged)="summaryPanelStateUpdates($event)"
      *appHideForUnavailableFeature="features.TradingLog"
    ></app-trading-log-symbol-summary-panel>
    @if (!showMaintenance) {
      <div class="right-side">
        <div
          (click)="wheelPositionSizing()"
          class="account-size"
        >
          <div class="size">
            <span>Buying Power</span>
            <p>${{ userSetting.wBuyingPower | number: '1.0-0' }}</p>
          </div>
          <div class="risk">
            <span>Pos.</span>
            <p>{{ userSetting.wMaxPosition }}</p>
          </div>
        </div>
      </div>
      <div class="view-mode-controls hide-on-max-991">
        <button
          [ngClass]="{ active: (wheelViewMode$ | async) === wheelViewModes.Tabs }"
          [matTooltip]="'Open chart and calculator each on their own page'"
          (click)="changeViewMode(wheelViewModes.Tabs)"
          disableRipple
          mat-icon-button
          class="view-mode-button"
        >
          <mat-icon
            svgIcon="tabs-mode-icon"
            class="middle-icon tabs-mode-icon"
          ></mat-icon>
        </button>
        <button
          [ngClass]="{ active: (wheelViewMode$ | async) === wheelViewModes.Split }"
          [matTooltip]="'View chart and calculator side-by-side on one page'"
          (click)="changeViewMode(wheelViewModes.Split)"
          mat-icon-button
          disableRipple
          class="view-mode-button"
        >
          <mat-icon
            svgIcon="split-mode-icon"
            class="middle-icon split-mode-icon"
          ></mat-icon>
        </button>
      </div>
    }
    <app-wheel-timer></app-wheel-timer>
  </div>
}

@if (!isMobile && !showMaintenance) {
  <div
    [ngClass]="{ 'with-banner': isBanner, hidden: isWheelScannerLoadingFirstTime && selectedTab === chartTabs.Chart }"
    class="wheel-section"
    id="wheel-section"
  >
    <as-split
      (dragStart)="onDragStart()"
      (dragEnd)="saveWheelFiltersWidth($event); onDragEnd()"
      direction="horizontal"
      class="all-section"
      gutterSize="6"
      unit="percent"
    >
      <as-split-area
        [size]="getLeftPartWidth()"
        minSize="25"
        class="left-section"
      >
        @if ((viewMode$ | async) === viewModes.Split) {
          <div
            [ngClass]="{ 'chart-tab': selectedTab === chartTabs.Chart }"
            class="left-side"
          >
            <app-symbol-menu
              [elementsTabVisibilityConfig]="wheelSplitModeTabsVisibilityConfig"
              [tab]="selectedTab"
              [isOpened]="isSymbolMenuOpened"
              [securityId]="currentSymbol$ | async"
              [tradingLogSymbolSummaryPanelSelectedGroupId]="tradingLogSymbolSummaryPanelSelectedGroupId"
              (rescuePanelLinesChange)="onLinesChange($event)"
              (tabChanged)="onTabChanged($event)"
              (toggleSymbolMenu)="onSymbolMenuToggle()"
              (changeSecurityId)="changeSecurityId($event)"
              (changeGroupId)="changeGroupId($event)"
            >
            </app-symbol-menu>
            @if (selectedTab === chartTabs.Chart) {
              <as-split
                (dragStart)="onDragStart()"
                (dragEnd)="saveWheelChartHeight($event); onDragEnd()"
                direction="vertical"
                gutterSize="6"
                unit="percent"
              >
                <as-split-area
                  [minSize]="wheelChartSectionMinHeightInPercents"
                  [size]="wheelChartSectionHeightInPercents"
                >
                  <div class="chart-back-layout">
                    <div class="chart-inner-layout">
                      <app-wheel-chart
                        [tradingLogSymbolSummaryPanelItemValuesModel]="tradingLogSymbolSummaryPanelItemValues"
                        class="h-less-991"
                      ></app-wheel-chart>
                      @if (isShowChartOverlay) {
                        <div class="chart-overlay"></div>
                      }
                    </div>
                  </div>
                </as-split-area>
                <as-split-area
                  [minSize]="wheelCalcSectionMinHeightInPercents"
                  [size]="wheelCalcSectionHeightInPercents"
                >
                  <app-wheel-calculator></app-wheel-calculator>
                </as-split-area>
              </as-split>
            }
          </div>
        }
        @if ((viewMode$ | async) === viewModes.Tabs) {
          <div class="chart-wheel">
            <div
              [ngClass]="{ 'chart-tab': selectedTab === chartTabs.Chart }"
              class="left-side"
            >
              <app-symbol-menu
                [elementsTabVisibilityConfig]="wheelTabsVisibilityConfig"
                [tab]="selectedTab"
                [isOpened]="isSymbolMenuOpened"
                [securityId]="currentSymbol$ | async"
                [tradingLogSymbolSummaryPanelSelectedGroupId]="tradingLogSymbolSummaryPanelSelectedGroupId"
                (rescuePanelLinesChange)="onLinesChange($event)"
                (tabChanged)="onTabChanged($event)"
                (toggleSymbolMenu)="onSymbolMenuToggle()"
                (changeSecurityId)="changeSecurityId($event)"
                (changeGroupId)="changeGroupId($event)"
              >
                <ng-container calculator>
                  <app-wheel-calculator></app-wheel-calculator>
                </ng-container>
              </app-symbol-menu>
              @if (selectedTab === chartTabs.Chart) {
                <app-wheel-chart
                  [tradingLogSymbolSummaryPanelItemValuesModel]="tradingLogSymbolSummaryPanelItemValues"
                  class="h-less-991"
                ></app-wheel-chart>
              }
            </div>
          </div>
        }
      </as-split-area>
      <as-split-area
        [size]="getRightPartWidth()"
        [minSize]="getRightPartMinWidth()"
        [maxSize]="getRightPartMaxWidth()"
        [ngClass]="{ 'pinned-order': showOrderPanel || showRescuePanel }"
        class="right-section pinned-order"
      >
        @if (showOrderPanel) {
          <app-trading-panel-order-panel></app-trading-panel-order-panel>
        }
        @if (showRescuePanel) {
          <app-rescue-panel
            [groupId]="tradingLogSymbolSummaryPanelSelectedGroupId"
            [securityId]="currentSymbol$ | async"
            (linesChange)="onLinesChange($event)"
          ></app-rescue-panel>
        }
        <as-split
          (dragStart)="onDragStart()"
          (dragEnd)="saveWheelFilterHeight($event); onDragEnd()"
          direction="vertical"
          gutterSize="6"
        >
          <as-split-area
            [size]="wheelFilterHeight"
            minSize="40"
            class="right-one"
          >
            <app-wheel-scanner (changeCurrentSymbol)="onSetCurrentSymbol($event)"></app-wheel-scanner>
          </as-split-area>
          <as-split-area
            [size]="wheelDataWindowHeight"
            [minSize]="dataWindowMinHeightInPercents"
            class="right-two"
            gutterSize="11"
          >
            <app-wheel-datawindow (openNews)="onTabChanged(chartTabs.News)"></app-wheel-datawindow>
          </as-split-area>
        </as-split>
      </as-split-area>
    </as-split>
  </div>
}

<!--------------------------------------------------------------
This is separate fragment for only mobile UI
--------------------------------------------------------------->
@if (isMobile && !showMaintenance) {
  <div class="wheel-container scroll-style">
    <div class="main-menu">
      <div class="mobile-header">
        <mat-icon
          [svgIcon]="'wheel-icon'"
          class="sub-menu-strategy-icon"
        ></mat-icon>
        <div class="menu-title">
          {{ strategiesNames.Wheel }}
        </div>
      </div>
      <div class="search-bar-section">
        <div class="header-container desktop-header">
          <p class="header with-divider">
            {{ strategiesNames.Wheel }}
          </p>
        </div>
        <app-search-bar
          [isPowerX]="false"
          #appSearchBar
        ></app-search-bar>
        <!--     use as a slot into symbol-search     -->
        <!-- <app-ai-chat-analyze-button
        [trigger]="analyzeTriggerDetails()"
        *appHideForUnavailableFeature="features.PxoAiChat"
        hint="Analyze this symbol"
      ></app-ai-chat-analyze-button> -->
      </div>
      <app-trading-log-symbol-summary-panel
        [state]="observableServiceV2.tradingLogSymbolSummaryPanelWheelState.value"
        [symbolName]="appSearchBar.selectedSymbol?.symbol"
        (selected)="summaryPanelValueSelected($event)"
        (statechanged)="summaryPanelStateUpdates($event)"
        *appHideForUnavailableFeature="features.TradingLog"
      ></app-trading-log-symbol-summary-panel>
      @if (!showMaintenance) {
        <div class="right-side">
          <div
            (click)="wheelPositionSizing()"
            class="account-size"
          >
            <div class="size">
              <span>Buying Power</span>
              <p>${{ userSetting.wBuyingPower | number: '1.0-0' }}</p>
            </div>
            <div class="risk">
              <span>Pos.</span>
              <p>{{ userSetting.wMaxPosition }}</p>
            </div>
          </div>
        </div>
        <div class="view-mode-controls hide-on-max-991">
          <button
            [ngClass]="{ active: (wheelViewMode$ | async) === wheelViewModes.Tabs }"
            (click)="changeViewMode(wheelViewModes.Tabs)"
            mat-icon-button
            class="view-mode-button"
          >
            <mat-icon
              svgIcon="tabs-mode-icon"
              class="middle-icon tabs-mode-icon"
            ></mat-icon>
          </button>
          <button
            [ngClass]="{ active: (wheelViewMode$ | async) === wheelViewModes.Split }"
            (click)="changeViewMode(wheelViewModes.Split)"
            mat-icon-button
            class="view-mode-button"
          >
            <mat-icon
              svgIcon="split-mode-icon"
              class="middle-icon split-mode-icon"
            ></mat-icon>
          </button>
        </div>
      }
      <app-wheel-timer></app-wheel-timer>
    </div>
    @if (isMobile && !showMaintenance) {
      <div
        [ngClass]="{ hidden: isWheelScannerLoadingFirstTime }"
        class="wheel-section"
      >
        <div class="chart-wheel">
          <div class="right-side-content scroll-style">
            <div class="wheel-scanner-part">
              <div class="consAndAgg">
                <app-wheel-scanner (changeCurrentSymbol)="onSetCurrentSymbol($event)"></app-wheel-scanner>
              </div>
              <div class="premiums-chart-tabbing">
                <div
                  [ngClass]="{ 'chart-tab': selectedTab === chartTabs.Chart }"
                  class="left-side"
                >
                  <app-symbol-menu
                    [elementsTabVisibilityConfig]="wheelTabsVisibilityConfig"
                    [tab]="selectedTab"
                    [securityId]="currentSymbol$ | async"
                    [tradingLogSymbolSummaryPanelSelectedGroupId]="tradingLogSymbolSummaryPanelSelectedGroupId"
                    (rescuePanelLinesChange)="onLinesChange($event)"
                    (tabChanged)="onTabChanged($event)"
                    (changeSecurityId)="changeSecurityId($event)"
                    (changeGroupId)="changeGroupId($event)"
                  >
                    <ng-container data-window>
                      <app-wheel-datawindow (openNews)="onTabChanged(chartTabs.News)"></app-wheel-datawindow>
                    </ng-container>
                    <ng-container calculator>
                      <app-wheel-calculator></app-wheel-calculator>
                    </ng-container>
                  </app-symbol-menu>
                  @if (selectedTab === chartTabs.Chart) {
                    <app-wheel-chart
                      [tradingLogSymbolSummaryPanelItemValuesModel]="tradingLogSymbolSummaryPanelItemValues"
                    ></app-wheel-chart>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (isWheelScannerLoadingFirstTime && !showMaintenance && selectedTab === chartTabs.Chart) {
  <div class="spinner-container">
    <mat-spinner
      class="blue-spinner"
      diameter="50"
    ></mat-spinner>
  </div>
}
